import { useLanguageContext } from 'context/LanguageProvider';
import './style.css';
import { siteConfiguration } from 'siteConfig';
import Button from 'components/Button/Button';

const WebsiteMarketing = () => {
	const { WebsiteMarketing, Schedule } = siteConfiguration;
	const { currentLanguage } = useLanguageContext();

	return (
		<div className="webmarketing-section wrapper">
			<div className="webmarketing-content">
				<div>
					<h2 className="webmarketing-text">{WebsiteMarketing.marketingContent[currentLanguage]}</h2>
					<Button
						text={Schedule.btnName[currentLanguage]}
						route={Schedule.link}
					/>
				</div>
			
				<div className="image">
					<img
						src={WebsiteMarketing.picture}
						className="webmarketing-image"
						alt="Mask-group"
					/>
				</div>
			</div>
				
		</div>
	);
};

export default WebsiteMarketing;
